import { IconProps } from './types'

export default function IconPausePlain({
    width = '16',
    height = '16',
    className,
}: IconProps) {

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 16 16'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            className={className}
        >
            <path d='M3.12429 1.89713L6.23802 1.7616L7.35207 14.2297L3.3029 14.3652L3.12429 1.89713Z' fill='url(#paint0_linear_8728_19832)' />
            <path d='M9.3457 1.83203L13.3977 1.8036L12.8616 14.3019L9.43282 14.309L9.3457 1.83203Z' fill='url(#paint1_linear_8728_19832)' />
            <defs>
                <linearGradient id='paint0_linear_8728_19832' x1='5.32749' y1='14.2974' x2='4.90939' y2='1.80607' gradientUnits='userSpaceOnUse'>
                    <stop stop-color='#C8E3F7' />
                    <stop offset='1' stop-color='white' />
                </linearGradient>
                <linearGradient id='paint1_linear_8728_19832' x1='11.1471' y1='14.3139' x2='11.0594' y2='1.82001' gradientUnits='userSpaceOnUse'>
                    <stop stop-color='#C8E3F7' />
                    <stop offset='1' stop-color='white' />
                </linearGradient>
            </defs>
        </svg>
    )
}
